/**
 * /equipment — layout for the equipment-costing module.
 *
 * The bare /equipment renders the register at _auth.equipment.index.tsx;
 * /equipment/$equipmentId, /equipment/cost-posting etc. each have their
 * own files. This wrapper just provides an Outlet.
 */
import { Outlet, createFileRoute } from "@tanstack/react-router";

export const Route = createFileRoute("/_auth/equipment")({
  component: () => <Outlet />,
});
